import Vue from 'vue';
import Router from 'vue-router';

import HomePage from '@/components/HomePage';
// import InfoPage from '@/components/InfoPage';
import CategoriesPage from '@/components/CategoriesPage';
import CareersPage from '@/components/CareersPage';
import FavoritesPage from '@/components/FavoritesPage';
import ResourcesPage from '@/components/ResourcesPage';
import FeedbackPage from '@/components/FeedbackPage';

Vue.use(Router);

export default new Router({
   mode: 'history',
   routes: [
      {
         path: '/',
         name: 'Home',
         component: HomePage,
      },
      /* info page is no longer used
      {
         path: '/info',
         name: 'Info',
         component: InfoPage,
      },
      */
      {
         path: '/categories',
         name: 'Categories',
         component: CategoriesPage,
      },
      {
         path: '/careers',
         name: 'Careers',
         component: CareersPage,
      },
      {
         path: '/favorites',
         name: 'Favorites',
         component: FavoritesPage,
      },
      {
         path: '/resources',
         name: 'Resources',
         component: ResourcesPage,
      },
      {
         path: '/feedback',
         name: 'Feedback',
         component: FeedbackPage,
      },
   ],
   scrollBehavior(to, from, savedPosition) {
      if (savedPosition) {
         return savedPosition;
      } else if (to.hash) {
         return {
            selector: to.hash,
         };
      }
   },
});



// WEBPACK FOOTER //
// ./src/router/index.js